import { render, staticRenderFns } from "./leftNavBar.vue?vue&type=template&id=68ac8660&scoped=true"
import script from "./leftNavBar.vue?vue&type=script&lang=js"
export * from "./leftNavBar.vue?vue&type=script&lang=js"
import style0 from "./leftNavBar.vue?vue&type=style&index=0&id=68ac8660&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ac8660",
  null
  
)

export default component.exports